webpackJsonp([58107522595176],{

/***/ 69:
/***/ (function(module, exports) {

	module.exports = function (string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	}
	
	module.exports.words = function (string) {
	  return string.replace(/(^|[^a-zA-Z\u00C0-\u017F'])([a-zA-Z\u00C0-\u017F])/g, function (m) {
	    return m.toUpperCase()
	  })
	}


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-auto-flow: row;\n  grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n  grid-auto-rows: ', ';\n  grid-gap: ', ';\n\n  width:calc(100% - ', ');\n  max-width:', ';\n  margin:0 auto;\n  margin-bottom: ', ';\n  ', '\n  a{\n    ', '\n    font-size: 0.8rem;\n    div{\n      height:100%;\n      width:100%;\n    }\n    background-color: unset;\n  }\n  p{\n    position:absolute;\n    bottom:0;\n    font-weight:400;\n    padding-right: ', ';\n    margin-bottom: ', ';\n  }\n\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  ', '\n'], ['\n  display: grid;\n  grid-auto-flow: row;\n  grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n  grid-auto-rows: ', ';\n  grid-gap: ', ';\n\n  width:calc(100% - ', ');\n  max-width:', ';\n  margin:0 auto;\n  margin-bottom: ', ';\n  ', '\n  a{\n    ', '\n    font-size: 0.8rem;\n    div{\n      height:100%;\n      width:100%;\n    }\n    background-color: unset;\n  }\n  p{\n    position:absolute;\n    bottom:0;\n    font-weight:400;\n    padding-right: ', ';\n    margin-bottom: ', ';\n  }\n\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(14);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// const tile = presets.blogTileSize;
	// const tile = rhythm(5);
	var mobileTile = "12em";
	var phabletTile = "10em";
	var tabletPorTile = "12em";
	var tabletLanTile = "12em";
	// we didn't need the rest of these presets:
	// const desktopTile = "120px" ;
	// const hdTile = "120px" ;
	// const vhdTile = "120px" ;
	// const vvhdTile = "120px" ;
	// const fourk = "120px" ;
	
	var SeeGrid = _styledComponents2.default.div(_templateObject, mobileTile, mobileTile, (0, _typography.rhythm)(1), (0, _typography.rhythm)(2), (0, _typography.rhythm)(28), (0, _typography.rhythm)(1.5), '' /* repeat(number of columns/rows, the column width we want); */, _presets2.default.shadowLow, (0, _typography.rhythm)(0.5), (0, _typography.rhythm)(0.5), _presets2.default.phablet.por, phabletTile, phabletTile, _presets2.default.tablet.por, tabletPorTile, tabletPorTile, _presets2.default.tablet.lan, tabletLanTile, tabletLanTile, '' /* @media screen and ${presets.desktop.lan}{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          @media screen and ${presets.hd.lan}{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          @media screen and ${presets.vhd.lan}{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          @media screen and ${presets.vvhd.lan}{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          } */);
	exports.default = SeeGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(14);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _typography = __webpack_require__(3);
	
	var _capitalize = __webpack_require__(69);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _Section = __webpack_require__(26);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _Crosshairs = __webpack_require__(25);
	
	var _Crosshairs2 = _interopRequireDefault(_Crosshairs);
	
	var _Content = __webpack_require__(24);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Title = __webpack_require__(28);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Tag = __webpack_require__(27);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Cta = __webpack_require__(40);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _P = __webpack_require__(46);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _SeeGrid = __webpack_require__(116);
	
	var _SeeGrid2 = _interopRequireDefault(_SeeGrid);
	
	var _H = __webpack_require__(45);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _H3 = __webpack_require__(65);
	
	var _H4 = _interopRequireDefault(_H3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SeePage = function SeePage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'See what we\'re making | SUPERFRAME'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Just some of the computer generated videos and images we produce at SUPERFRAME.' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      { style: {
	          textAlign: 'center',
	          textTransform: 'capitalize',
	          margin: '0',
	          padding: (0, _typography.rhythm)(3) + ' 0'
	        } },
	      'what we\'re making'
	    ),
	    _react2.default.createElement(
	      _SeeGrid2.default,
	      null,
	      data.allSeeYaml.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            key: node.id,
	            to: '' + node.fields.slug,
	            style: { position: 'relative' },
	            alt: node.title,
	            title: node.title },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: node.image.childImageSharp.sizes,
	            position: 'relative',
	            alt: node.title
	          }),
	          _react2.default.createElement(
	            _Tag2.default,
	            null,
	            (0, _capitalize2.default)(node.title)
	          ),
	          node.video != null ? _react2.default.createElement(
	            _P2.default,
	            { brand: true,
	              style: {
	                position: 'absolute',
	                top: '0',
	                left: '0',
	                fontSize: '' + (0, _typography.rhythm)(0.5),
	                marginTop: '' + (0, _typography.rhythm)(0.25),
	                marginLeft: '' + (0, _typography.rhythm)(0.25)
	              } },
	            '[video]'
	          ) : ""
	        );
	      })
	    ),
	    _react2.default.createElement('div', { style: { textAlign: 'center' } })
	  );
	};
	
	exports.default = SeePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-see-js-7a1abe04d0888a68df40.js